import axios from "./AxiosInstance"

const getWorkshops = (userId) => {
    const url = `api/events?paginated=false&typeId=1&isDE=true`
    return axios.get(url)
}
const getWorkshopById = (workshopId) => axios.get(`api/events/${workshopId}`)
const joinWorkshop = (workshopId, sessionId) => axios.post(`api/events/${workshopId}/register/${sessionId}`)

export const WorkShopService = {
    getWorkshops,
    getWorkshopById,
    joinWorkshop
}
